import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@radix-ui/themes/styles.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
// import { BrowserRouter } from "react-router-dom";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Theme } from "@radix-ui/themes";
import themeConfig from "./config/radixTheme";
import { GoogleOAuthProvider } from "@react-oauth/google";
import Profile from "./components/dashboard/profile";
// import SignupWithGoogle from "./components/signup/signupWithGoogle";
import InterviewScreen from "./components/interview/interview";
import Dashboard from "./components/dashboard/dashboard";
import HelpCenter from "./components/reusble_components/helpCenter";
import MobileBottomNavBar from "./components/navbar/mobileNavbar";
import ReportScreen from "./components/reusble_components/reportScreen";
import BasicDetails from "./components/dashboard/basicDetails";
import LearninngTab from "./components/learn/learningTab";
import Learn from "./components/dashboard/learn";
import ReactHookSpeech from "./components/interview/reactHookSpeech";
import RazorPayGateway from "./components/payment/razor_pay";
import PaymentSuccess from "./components/payment/payment_success";
import Certificate from "./components/certificate/certificate";
import CourseCertificate from "./components/certificate/CourseCertificate";
import Mistakes from "./components/dashboard/mistakes";
// import Register from "./components/dashboard/register";
import ResumeOutput from "./components/resume/resume_output";
// import RegisterDetails from "./components/dashboard/registerDetails";
import WaitlistSuccess from "./components/dashboard/company";
import ResumeDetails from "./components/resume1/resumeDetails";
import DeleteMyAccount from "./components/signup/deleteMyAccount";
import ResumeCard from "./components/dashboard/ResumeCard";
import AzureImageUploader from "./components/azure/image";
import Recruiter from "./components/recruiter/recruiter";
import ReactGA from "react-ga4";
import DashboardRecruiter from "./components/recruiter/dashboard";
import Share from "./components/share/share";
import InterviewInvitation from "./components/interview/interview_invitation";
import SignupPage1 from "./components/signup/SignupPage1";
import MockExamReport from "./components/dashboard/mockexamreport";
import Test from "./components/mockTest/Test";
import CreateMockTest from "./components/mockTest/CreateMockTest";
// import Career from "./components/dashboard/Career";
import CareerDetails from "./components/career/CareerDetails";
import Answer from "./components/mockTest/Answer";
import { MeetingCreationForm } from "./components/dashboard/MeetingCreation";
import SignupPage2 from "./components/signup_2/SignupPage2";
import Register2 from "./components/signup_2/register";
import ResetPassword from "./components/signup_2/ResetPassword";
import Test1 from "./components/JobPost/Test1";
import JobShare from "./components/recruiter/Components/Job";
import Popup from "./components/recruiter/Components/skipPopup";
import JobOverview from "./components/recruiter/jobPreview/mainPage";
import Internship from "./components/career/JobInternship";
import JobDetails from "./components/career/components/page";
import ReportOverview from "./components/recruiter/ReportOverview";
import ApplicantsDetails from "./components/recruiter/applicantsDetails";
import History, { JobPostReport } from "./components/dashboard/history";
import CompanyApplicants from "./components/recruiter/companyApplicants";
import ViewCredits from "./components/dashboard/viewCredits";
import DeleteAccountWithhId from "./components/signup/deleteAccountWithId";
import Behaviour from "./components/reusble_components/behavioural";
import TermsOfUse from "./components/dashboard/TermsOfUse";
import PrivacyPolicy from "./components/dashboard/Privacy";
import JobApplicantDetails from "./components/recruiter/jobApplicantDetails";
import Main from "./components/recruiterNew/main";
import InterviewApplicant from "./components/recruiter/interviewApplicant";
import InterviewReport from "./components/recruiter/interviewReport";
import HistoryPage from "./components/career/HistoryPage";
import AccountVerification from "./components/recruiter/AccountVerification";
import MobileReportOverview from "./components/recruiter/mobileOverview";
import TransactionCards from "./components/reusble_components/Pricing/transactionCards";
import { MeetingCreationForm2 } from "./components/dashboard/MeetingCreation2";
import Payment from "./components/payment/payment";
import RadixExample from "./components/UI/RadixExample";
import AutoLogin from "./components/auth/AutoLogin";
import SessionExpiryDialog from "./components/auth/SessionExpiryDialog";

ReactGA.initialize("G-1W2KS2H78Z");
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Theme {...themeConfig}>
    <GoogleOAuthProvider clientId="654679328512-icojr7ogsote0f21jdmvfdpboteh2h6q.apps.googleusercontent.com">
      <BrowserRouter>
        <SessionExpiryDialog />
        <AutoLogin />
        <Routes>
          <Route path="/radix-example" element={<RadixExample />} />
          <Route
            path="/"
            element={<SignupPage2 />}
            children={<Route path="*" element={<SignupPage2 />} />}
          />

          <Route
            path="/signup"
            element={<SignupPage1 />}
            children={<Route path="*" element={<SignupPage1 />} />}
          />
          <Route path="/delete-account" element={<DeleteMyAccount />} />
          <Route
            path="/delete-account-with-id"
            element={<DeleteAccountWithhId />}
          />
          <Route path="/recruiter" element={<Recruiter />}></Route>
          <Route
            path="/share/job-applicants/:id"
            element={<JobApplicantDetails enable={false} />}
          />
          <Route
            path="/share/applicant/:id"
            element={<MobileReportOverview enable={false} />}
          />
          <Route
            path="/share/mcq-applicants"
            element={<ApplicantsDetails mock={true} />}
          />
          <Route
            path="/share/mcq-applicants/:id"
            element={<ApplicantsDetails mock={true} />}
          />
          <Route path="/share/applicants" element={<ApplicantsDetails />} />
          <Route path="/share/applicants/:id" element={<ApplicantsDetails />} />
          <Route
            path="/dashboard"
            element={<Profile />}
            children={<Route path="*" element={<Profile />} />}
          />

          <Route
            path="jobshare"
            element={<JobShare />}
            children={<Route path="" element={<JobShare />} />}
          />
          <Route
            path="/skip"
            element={<Popup />}
            children={<Route path="*" element={<Popup />} />}
          />

          <Route
            path="/jobPreview"
            element={<JobOverview />}
            children={<Route path="*" element={<JobOverview />} />}
          />
          <Route
            path="/share"
            element={<Share />}
            children={<Route path="*" element={<Share />} />}
          />
          <Route
            path="/JobInternship"
            element={<Internship />}
            children={<Route path="*" element={<Internship />} />}
          />
          <Route
            path="/jobpost/:id"
            element={<JobDetails />}
            children={<Route path="*" element={<JobDetails />} />}
          />
          <Route
            path="/newone/:id"
            element={<JobPostReport />}
            children={<Route path="*" element={<JobPostReport />} />}
          />

          <Route
            path="/newreport"
            element={<ReportOverview />}
            children={<Route path="*" element={<ReportOverview />} />}
          />

          <Route path="/career-details" element={<CareerDetails />} />

          <Route path="/mockexamreport" element={<MockExamReport />} />
          <Route path="/mockexamreport/:id" element={<MockExamReport />} />

          <Route path="/mock" element={<Test />} />
          <Route path="/mock-answer" element={<Answer />} />
          <Route path="/createmocktest" element={<CreateMockTest />} />
          <Route
            path="/interview-invitation"
            element={<InterviewInvitation takeInterview={true} />}
            children={
              <Route
                path="*"
                element={<InterviewInvitation takeInterview={true} />}
              />
            }
          />

          <Route
            path="/interview_invitation"
            element={<InterviewInvitation takeInterview={true} />}
            children={
              <Route
                path="*"
                element={<InterviewInvitation takeInterview={true} />}
              />
            }
          />

          <Route
            path="/company"
            element={<DashboardRecruiter />}
            children={<Route path="*" element={<DashboardRecruiter />} />}
          />

          <Route path="/company-waiting" element={<WaitlistSuccess />} />

          <Route
            path="/talent-pool"
            element={<CompanyApplicants />}
            children={<Route path="*" element={<CompanyApplicants />} />}
          />
          <Route path="/view-credits" element={<ViewCredits />} />

          <Route
            path="/interview"
            element={<InterviewScreen />}
            // children={<Route path="*" element={<Profile />} />}
          />
          <Route path="/signup_2" element={<SignupPage2 />} />
          <Route path="/register" element={<Register2 />} />
          <Route path="/validate-email/:id" element={<Register2 />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/payment/:id" element={<Payment />} />

          <Route path="/report/:id" element={<ReportScreen />} />
          <Route path="/newreport/:id" element={<InterviewReport />} />
          <Route path="/resumedetails" element={<ResumeDetails />} />
          <Route path="/helpcenter" element={<HelpCenter />} />
          <Route path="/english" element={<Mistakes />} />
          <Route
            path="/dashboardresponsive"
            element={<Dashboard />}
            // children={<Route path="*" element={<Profile />} />}
          />
          <Route path="/navbar" element={<MobileBottomNavBar />} />
          <Route path="/details" element={<BasicDetails />} />
          <Route
            path="/course/:id"
            element={<LearninngTab />}
            children={<Route path="*" element={<LearninngTab />} />}
          />
          <Route path="/learn" element={<Learn />} />
          <Route path="/test" element={<ReactHookSpeech />} />
          <Route path="/razorpay" element={<RazorPayGateway />} />
          <Route path="/payment-razorpay/:id" element={<RazorPayGateway />} />
          <Route
            path="/check-payment-status/:id"
            element={<PaymentSuccess />}
          />
          <Route
            path="/subscription/successfull"
            element={<TransactionCards status={"success"} />}
          />
          <Route
            path="/subscription/failed"
            element={<TransactionCards status={"failure"} />}
          />
          <Route
            path="/subscription/pending"
            element={<TransactionCards status={"pending"} />}
          />
          <Route
            path="/TermsOfUse"
            element={<TermsOfUse />}
            children={<Route path="*" element={<TermsOfUse />} />}
          />

          <Route
            path="/PrivacyPolicy"
            element={<PrivacyPolicy />}
            children={<Route path="*" element={<PrivacyPolicy />} />}
          />

          <Route
            path="*"
            element={
              <div>
                <h1>404</h1>
              </div>
            }
          />
          <Route path="/Report" element={<Certificate />} />
          <Route
            path="/AccountVerification"
            element={<AccountVerification />}
          />
          <Route path="/Report/:id" element={<Certificate />} />
          <Route path="/CourseCertificate" element={<CourseCertificate />} />
          <Route path="/meeting-creation" element={<MeetingCreationForm />} />
          <Route
            path="/CourseCertificate/:id"
            element={<CourseCertificate />}
          />
          {/* <Route path="/" element={<Register />} /> */}

          <Route path="/resume" element={<ResumeOutput />} />

          {/* <Route path="/registerdetails" element={<RegisterDetails />}></Route> */}
          <Route path="/resumecard" element={<ResumeCard />}></Route>
          <Route path="/azure" element={<AzureImageUploader />}></Route>
          <Route path="/test1" element={<Test1 />}></Route>
          <Route path="/behaviour" element={<Behaviour />}></Route>
          <Route path="/meeting-form" element={<MeetingCreationForm2 />} />
        </Routes>
        {/* <App /> */}
      </BrowserRouter>
    </GoogleOAuthProvider>
  </Theme>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
